import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Button, Glyphicon } from '@bingads-webui-react/primitive';
import ButtonAddRemove from './button-add-remove';
import Item from './item';

export default class SelectedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: true,
    };
  }

  expandToggle = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded,
    }));
  }

  updateOne = (item) => {
    this.props.onChange(false, this.props.category, [item]);
  }

  updateMany = (items) => {
    this.props.onChange(false, this.props.category, items);
  }

  render() {
    const { categoryObject } = this.props;
    const orderedList = _.intersection(categoryObject.data.items, categoryObject.data.selected);
    const unavailableItems = _.difference(categoryObject.data.selected, categoryObject.data.items);
    const allShowItems = categoryObject.data.showUnavailableItem ?
      _.union(orderedList, unavailableItems) : orderedList;

    if (allShowItems.length > 0) {
      return (
        <Grid fluid className={`selected-list-box ${this.props.className}`}>
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={12} onClick={this.expandToggle}>
                  <Button
                    className="category-name-button"
                    aria-label={this.props.i18n.getString(this.state.isExpanded ? 'DoubleListBox_Expand' : 'DoubleListBox_Collapse')}
                  >
                    <Glyphicon glyph={this.state.isExpanded ? 'chevron-up' : 'chevron-down'} />
                    <span className="category-name">{`${categoryObject.name} : ${allShowItems.length} ${this.props.i18n.getString('DoubleListBox_Selected')}`}</span>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Row className={this.state.isExpanded ? 'expanded' : 'collapsed'}>
                    <Col sm={12}>
                      <Row>
                        <Col sm={12}>
                          <ButtonAddRemove className="selected-remove" onClick={() => this.updateMany(allShowItems)} add={false} i18n={this.props.i18n} />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          {orderedList.map(item =>
                            (<Item
                              key={item}
                              value={item}
                              selected
                              onChange={() => this.updateOne(item)}
                              i18n={this.props.i18n}
                            />))}
                          {
                            categoryObject.data.showUnavailableItem &&
                            unavailableItems.map(item =>
                              (<Item
                                key={item}
                                value={item}
                                selected
                                className="unavailable-item"
                                onChange={() => this.updateOne(item)}
                                i18n={this.props.i18n}
                              />))
                          }
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      );
    }

    return (null);
  }
}

SelectedList.propTypes = {
  onChange: PropTypes.func.isRequired,
  category: PropTypes.number.isRequired,
  categoryObject: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    data: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
      selected: PropTypes.arrayOf(PropTypes.string),
      disabled: PropTypes.arrayOf(PropTypes.string),
      showUnavailableItem: PropTypes.bool,
    }).isRequired,
    notShowInSource: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
